module.exports = __webpack_public_path__ + "fonts/SuisseIntlCondensed-RegItalic.a2e27da.woff";